import React, { useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Typography } from "@mui/material";
import { enUS } from "@mui/x-date-pickers/locales";
import { StaticTimePicker } from "@mui/x-date-pickers";

import Dialog from "../Dialog";

interface IProps {
  handleSaveTime: (startTime: string, endTime: string) => void;
  closeStartEndTimePickerHandler: () => void;
}

const StartEndTimePicker: React.FC<IProps> = ({
  handleSaveTime,
  closeStartEndTimePickerHandler,
}) => {
  const [timePickerState, setTimePickerState] = useState<{
    value: null;
    startTime: string | null;
    endTime: string | null;
    showEndTimePicker: boolean;
  }>({
    value: null,
    startTime: null,
    endTime: null,
    showEndTimePicker: false,
  });

  const customLocaleText = {
    ...enUS.components.MuiLocalizationProvider.defaultProps.localeText,
    okButtonLabel: timePickerState.showEndTimePicker ? "Done" : "Next",
  };

  const handleAccept = (value) => {
    const val = value.format("HH:mm");
    if (!timePickerState.showEndTimePicker) {
      setTimePickerState({
        ...timePickerState,
        startTime: val,
        showEndTimePicker: true,
        value: null,
      });
      handleSaveTime(val, timePickerState.endTime);
    } else {
      setTimePickerState({
        ...timePickerState,
        endTime: val,
        showEndTimePicker: false,
        value: null,
      });
      handleSaveTime(timePickerState.startTime, val);
    }
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      localeText={customLocaleText}
    >
      <DemoContainer
        components={["MobileTimePicker", "MobileTimePicker"]}
        sx={{ overflow: "hidden", border: "0.8rem" }}
      >
        <Dialog isOpen={true} closeHandler={closeStartEndTimePickerHandler}>
          <Typography variant="h6" gutterBottom textAlign={"center"}>
            {timePickerState.showEndTimePicker
              ? "Select end time"
              : "Select start time"}
          </Typography>
          <StaticTimePicker
            key={timePickerState.showEndTimePicker ? "end-time" : "start-time"}
            value={timePickerState.value}
            onChange={(newValue) => {
              setTimePickerState({
                ...timePickerState,
                value: newValue,
              });
            }}
            slotProps={{
              actionBar: {
                actions: ["accept"],
              },
            }}
            openTo={"hours"}
            onAccept={handleAccept}
          />
        </Dialog>
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default StartEndTimePicker;
